import MainLayout from "@/layout/MainLayout.vue";

export const lectureRoutes = [
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "/vortraege",
        name: "lecture-list",
        component: () => import("@/views/lecture/LectureList.vue"),
        meta: { 
          permissions: ["normalUser"],
          redirectTo: { name: "dashboard" }
        }
      },
      {
        path: "/vortraege/create",
        name: "lecture.new",
        component: () => import("@/views/lecture/CreateLectureList.vue"),
        meta: { 
          permissions: ["normalUser"],
          redirectTo: { name: "dashboard" }
        }
      },
      {
        path: "/vortraege/:id",
        name: "lecture.view",
        component: () => import("@/views/lecture/LectureView.vue"),
        meta: { 
          permissions: ["normalUser"],
          redirectTo: { name: "dashboard" }
        }
      },
      {
        path: "/vortraege/:id/edit",
        name: "lecture.edit",
        component: () => import("@/views/lecture/EditLectureList.vue"),
        meta: { 
          permissions: ["normalUser"],
          redirectTo: { name: "dashboard" }
        }
      }
    ]
  }
]; 